import Mutations from '../../odata/mutations';

export default { ...new Mutations('purchaseOrder'), ...new Mutations('purchaseOrders') };
